import request from '@/utils/request'

let Risk_scope_identifyApi = {

  /*风险识别范围列表*/
  list(data) {
    return request._post('/shop/plus.risk_scope_identify.Index/index', data);
},
/*添加风险识别范围*/
add(data) {
    return request._post('/shop/plus.risk_scope_identify.Index/add', data);
},
/*修改风险识别范围*/
edit(data) {
    return request._post('/shop/plus.risk_scope_identify.Index/edit', data);
},
/*删除风险识别范围*/
del(data) {
    return request._post('/shop/plus.risk_scope_identify.Index/del', data);
},
/*风险识别范围详情*/
detail(data) {
  return request._post('/shop/plus.risk_scope_identify.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.risk_scope_identify.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.risk_scope_identify.Setting/getSetting', data, errorback);
    },
}
export default Risk_scope_identifyApi;



// WEBPACK FOOTER //
// ./src/api/risk_scope_identify.js